import { render, staticRenderFns } from "./ChecklistCompetenceDialog.vue?vue&type=template&id=3371feed&"
import script from "./ChecklistCompetenceDialog.vue?vue&type=script&lang=js&"
export * from "./ChecklistCompetenceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports